<template>
  <Headers> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <PogressBarStep :cardName="prop.cardName" :currentStep="10">
    </PogressBarStep>

    <div :class="[deviceType, 'inner']">
      <div :class="[deviceType, 'content']">
        <div class="line">
          <div class="frame-36345">
            <div class="pop-up-components">
              <div class="overlay" v-if="prop.otp.supplementaryOtp.validated">
                <div class="content2">
                  <div class="svg-container">
                    <AcknowledgementSuccessSvg></AcknowledgementSuccessSvg>
                  </div>
                  <div class="description">
                    {{ t("ccOnBoarding.contactVerification.verified") }}
                  </div>
                </div>
              </div>
              <!-- <div v-if="mobileOverlay" class="process_overlay">
                <div class="text-center flex-container">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">{{
                      t("ccOnBoarding.uploadDocument.loading2")
                    }}</span>
                  </div>
                </div>
              </div> -->
              <div class="main-title">
                <div class="enter-the-6-digit-co">
                  {{ t("ccOnBoarding.contactVerification.enter") }}
                </div>
                <div class="_60-86">
                  +{{
                    prop.contactInformation.supplementary.mobileCountryCode +
                    hiddenMobileNo
                  }}
                </div>
              </div>
              <div class="number-tile">
                <div class="_1023">{{ prop.otp.supplementaryOtp.pac }}</div>
              </div>
              <div
                class="text-field-6-digits"
                @click="focusInput"
                ref="textInput"
              >
                <input
                  v-for="(n, index) in prop.otp.supplementaryOtp.otp"
                  :key="index"
                  type="tel"
                  inputmode="numeric"
                  pattern="\d*"
                  :id="'input_' + index"
                  maxlength="1"
                  v-model="prop.otp.supplementaryOtp.otp[index]"
                  @input="handleInput"
                  @keypress="isNumber"
                  @keydown.delete="handleDelete"
                  @keydown.enter.prevent="handleEnterKey"
                  @paste="onPaste"
                  @change="handleAutoPopulate"
                  :style="{
                    borderColor: isInvalid[index] ? '#E4E4E4' : '#CB03BC',
                    font: 'Outfit',
                  }"
                  :disabled="
                    prop.otp.supplementaryOtp.full ||
                    maxOtp ||
                    expiredOtp ||
                    otpDown
                  "
                  :autocomplete="'new-password'"
                  tabindex="-1"
                />
              </div>
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-if="errorMessage && !maxOtp && !expiredOtp && !otpDown"
              >
 {{ t("otpWrong") }}</pre
              >
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-else-if="maxOtp && !expiredOtp && !otpDown"
              >
 {{ t("ccOnBoarding.otp.maxOTP") }}</pre
              >
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-else-if="!maxOtp && expiredOtp && !otpDown"
              >
 {{ t("ccOnBoarding.otp.expiredOtp") }}</pre
              >
              <pre
                class="help"
                style="
                  white-space: pre-wrap;
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                v-else-if="!maxOtp && !expiredOtp && otpDown"
              >
 {{ t("ccOnBoarding.otp.otpService") }}</pre
              >
              <pre class="helpNull" v-else></pre>

              <div class="bottom-footer">
                <div class="already-have-an-acco">
                  {{ t("ccOnBoarding.contactVerification.xreceive") }}
                </div>
                <div class="text-button-small">
                  <p
                    class="text-button-default"
                    v-if="countdown == 0 || countdown == 60"
                    @click="startCountdown"
                  >
                    {{ t("ccOnBoarding.contactVerification.resend") }}
                  </p>
                </div>
                <p
                  class="resendText"
                  v-if="countdown !== 60 && countdown != 0 && countdown > 9"
                >
                  {{ t("ccOnBoarding.contactVerification.resendIn") }} 00:{{
                    countdown
                  }}
                </p>
                <p
                  class="resendText"
                  v-if="countdown !== 60 && countdown != 0 && countdown <= 9"
                >
                  {{ t("ccOnBoarding.contactVerification.resendIn") }} 00:0{{
                    countdown
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div :class="[deviceType, 'buttoncontainer']">
          <button
            :class="[deviceType, 'left-button']"
            type="button"
            @click="back"
          >
            {{ t("ccOnBoarding.back") }}
          </button>
        </div>
        <PopupMessage
          name="'none'"
          :type="'none'"
          :header="'suppOtpLimit'"
          v-if="isTNCModalOpen"
          @close-modal="closeTNCModal"
          :popup="true"
          :token="prop.token"
        >
        </PopupMessage>
      </div>
    </div>
  </div>
  <!-- <div v-if="prop.overlay || page10Overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div> -->
</template>

<script setup lang="ts">
import Headers from "./components/Headers.vue";
import PogressBarStep from "./components/ProgressBarStep.vue";
import { ref, computed, watch, onMounted, type PropType } from "vue";
import CCOnboardFormService from "@/service/restfulService/CCOnboardFormService";
import i18n from "@/plugin/i18n";
import type FormCC from "@/interface/FormCC";
import { deviceDetect } from "mobile-device-detect";
import type FormCCOtp from "@/interface/FormCCOtp";
import PopupMessage from "./components/PopupMessage.vue";
import AcknowledgementSuccessSvg from "@/assets/icons/AcknowledgementSuccessSvg.vue";

const deviceType = ref("");

const prop = defineProps({
  contactInformation: {
    type: Object as PropType<FormCC>,
    required: true,
  },
  otp: {
    type: Object as PropType<FormCCOtp>,
    required: true,
  },
  cardName: {
    type: String,
    required: true,
  },
  suppId: {
    type: String,
    required: true,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  token: {
    type: String,
    required: true,
  },
});

const { t } = i18n.global;
const errorMessage = ref(false);
const maxOtp = ref(false);
const fail = ref(false);
const isFocused = ref(false);
const page10Overlay = ref(false);
const expiredOtp = ref(false);
const otpDown = ref(false);
const mobileOverlay = ref(false);

let isTNCModalOpen = ref(false);
let dataFromPaste: string[] | undefined;
const keysAllowed: string[] = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
];

onMounted(() => {
  defaultCountdown();
  const requestModel = {
    mobileNo:
      prop.contactInformation.supplementary.mobileCountryCode +
      prop.contactInformation.supplementary.mobileNo,
    mobileNoCountryCode:
      prop.contactInformation.supplementary.mobileCountryCode,
    webFormType: "cc",
    webFormRequestId: prop.contactInformation.webFormRequestId,
    skipToken: false,
  };
  if (!prop.otp.supplementaryOtp.success) {
    CCOnboardFormService.requestOTP(requestModel, prop.token)
      .then((res) => {
        if (res.status == 200) {
          prop.otp.supplementaryOtp.pac = res.data.responseModel.otp.otpPacNo;
        }
      })
      .catch((e) => {
        if (e.response && e.response.data.code == "WB-401") {
          // EndSession
          emit("tokenSessionTimeOut");
        }
        emit("submit");
      });
  }

  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

const countdown = ref(60);
let countdownTimer: number | null = null;

// const countdownReciprocal = computed(() => {
//   return countdown.value > 0 ? (1 / countdown.value).toFixed(2) : 0;
// });

// function getReciprocal() {
//   return countdownReciprocal.value;
// }

function defaultCountdown() {
  if (countdownTimer !== null) {
    clearInterval(countdownTimer);
  }

  prop.otp.supplementaryOtp.number = 0;
  prop.otp.supplementaryOtp.otp = Array(6).fill("");
  prop.otp.supplementaryOtp.needValidate = true;
  prop.otp.supplementaryOtp.full = false;
  maxOtp.value = false;

  countdown.value = 60 - 1; // Reset countdown to 60 seconds

  countdownTimer = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--;
    } else {
      clearInterval(countdownTimer as number);
      countdownTimer = null;
    }
  }, 1000);
}

function startCountdown() {
  if (countdownTimer !== null) {
    clearInterval(countdownTimer);
  }

  prop.otp.supplementaryOtp.number = 0;
  prop.otp.supplementaryOtp.otp = Array(6).fill("");
  prop.otp.supplementaryOtp.needValidate = true;
  prop.otp.supplementaryOtp.full = false;
  maxOtp.value = false;
  errorMessage.value = false;
  const requestModel = {
    mobileNo:
      prop.contactInformation.supplementary.mobileCountryCode +
      prop.contactInformation.supplementary.mobileNo,
    mobileNoCountryCode:
      prop.contactInformation.supplementary.mobileCountryCode,
    webFormType: "cc",
    webFormRequestId: prop.contactInformation.webFormRequestId,
    skipToken: false,
  };
  CCOnboardFormService.resendOTP(requestModel, prop.token)
    .then((res) => {
      if (res.status == 200) {
        maxOtp.value = false;
        prop.otp.supplementaryOtp.pac = res.data.responseModel.otp.otpPacNo;
        prop.otp.supplementaryOtp.resend = prop.otp.supplementaryOtp.resend + 1;
        prop.otp.supplementaryOtp.success = false;
        otpDown.value = false;
        expiredOtp.value = false;
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        emit("tokenSessionTimeOut");
      }
      emit("submit");
    });

  countdown.value = 60 - 1; // Reset countdown to 60 seconds

  countdownTimer = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--;
    } else {
      clearInterval(countdownTimer as number);
      countdownTimer = null;
    }
  }, 1000);
}

const hiddenMobileNo = computed(() => {
  if (prop.contactInformation.supplementary.mobileNo.length < 6) {
    return prop.contactInformation.supplementary.mobileNo;
  }

  const visibleLength = 0;
  const hiddenLength =
    prop.contactInformation.supplementary.mobileNo.length - 2;
  const hiddenChars = "*".repeat(hiddenLength);

  return (
    prop.contactInformation.supplementary.mobileNo.slice(0, visibleLength) +
    hiddenChars +
    prop.contactInformation.supplementary.mobileNo.slice(-2)
  );
});

function isNumber(event: Event) {
  (event.currentTarget as HTMLInputElement).value = "";
  const keyPressed: string = (event as KeyboardEvent).key;
  if (!keysAllowed.includes(keyPressed)) {
    event.preventDefault();
  }
}
const test = ref("");
// const codeIndexLength = computed(() => code.value.join(""));
function focusInput() {
  const codeIndexLength = computed(() =>
    prop.otp.supplementaryOtp.otp.join("")
  );
  if (codeIndexLength.value.length != 0) {
    const inputElement = document.getElementById(
      "input_" + codeIndexLength.value.length
    );

    if (inputElement) {
      inputElement.focus();
    }
  } else if (codeIndexLength.value.length == 0) {
    const inputElement = document.getElementById("input_" + 0);
    if (inputElement) {
      inputElement.focus();
    }
  }
}

const focusFrame = () => {
  isFocused.value = true;
};

const removeFocus = () => {
  isFocused.value = false;
};

function handleInput(event: Event) {
  const inputType = (event as InputEvent).inputType;
  let currentActiveElement = event.target as HTMLInputElement;
  const currentInputId = currentActiveElement.id;

  function getWordsBeforeUnderscore(id: string): string | null {
    const parts = id.split("_");
    if (parts.length > 1) {
      return parts[0];
    } else {
      return null;
    }
  }

  const wordsBeforeUnderscore = getWordsBeforeUnderscore(currentInputId);
  if (inputType === "insertText")
    (currentActiveElement.nextElementSibling as HTMLElement)?.focus();

  if (
    inputType === "insertFromPaste" &&
    dataFromPaste &&
    wordsBeforeUnderscore == "input"
  ) {
    for (const num of dataFromPaste) {
      let id: number = parseInt(currentActiveElement.id.split("_")[1]);
      currentActiveElement.value = num;
      prop.otp.supplementaryOtp.otp[id] = num;
      if (currentActiveElement.nextElementSibling) {
        currentActiveElement =
          currentActiveElement.nextElementSibling as HTMLInputElement;
        (currentActiveElement.nextElementSibling as HTMLElement)?.focus();
      }
    }
  }
  const isCodeArrayFull = prop.otp.supplementaryOtp.otp.every(
    (element) => element !== undefined && element !== null && element !== ""
  );

  if (isCodeArrayFull) {
    isFocused.value = true;
    prop.otp.supplementaryOtp.full = true;
  }
  // Validation
  if (isCodeArrayFull) {
    if (
      prop.otp.supplementaryOtp.needValidate &&
      prop.otp.supplementaryOtp.number < 3
    ) {
      if (prop.otp.supplementaryOtp.resend <= 51) {
        phoneOTP();
      }
    }
  }
}

const handleAutoPopulate = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  const index = parseInt((event.target as HTMLInputElement).id.split("_")[1]);
  if (value.length === 1 && index < prop.otp.supplementaryOtp.otp.length - 1) {
    const nextInput = document.getElementById(`input_${index + 1}`);
    if (nextInput) {
      nextInput.focus();
    }
  }
};

watch(
  [
    () => prop.otp.supplementaryOtp.resend,
    () => prop.otp.supplementaryOtp.number,
  ],
  ([resend, number], [prevResend, prevNumber]) => {
    if (resend == 50) {
      if (number >= 3) {
        fail.value = true;
      }
    } else if (resend == 51) {
      fail.value = true;
    }
  }
);

watch(
  () => fail.value,
  (newValue) => {
    if (newValue == true) {
      isTNCModalOpen.value = true;
      // emit("jumpStep", 12, "", 10);
    }
  }
);

const closeTNCModal = () => {
  isTNCModalOpen.value = false;
  emit("submit");
};

watch(
  [() => prop.otp.supplementaryOtp.validated],
  ([newValue1], [oldValue1]) => {
    // Check for changes in variable1 or variable2 and execute method if needed
    if (newValue1 === true) {
      checkOtpResult();
    }
  }
);

function handleDelete(event: Event) {
  const codeIndexLength = computed(() =>
    prop.otp.supplementaryOtp.otp.join("")
  );
  const inputElement = document.getElementById(
    "input_" + codeIndexLength.value.length
  );

  let value = (event.target as HTMLInputElement).value;
  let currentActiveElement = inputElement as HTMLInputElement;

  if (!value) {
    const previousElement =
      currentActiveElement.previousElementSibling as HTMLInputElement;
    if (previousElement) {
      previousElement.focus();

      prop.otp.supplementaryOtp.otp[codeIndexLength.value.length - 1] = "";
    }
  }
}

const handleEnterKey = () => {};

function onPaste(event: Event) {
  dataFromPaste = (event as ClipboardEvent).clipboardData
    ?.getData("text")
    .trim()
    .split("");

  if (dataFromPaste) {
    for (const num of dataFromPaste) {
      if (!keysAllowed.includes(num)) event.preventDefault();
    }
  }
}

const isInvalid = computed(() => {
  return prop.otp.supplementaryOtp.otp.map((input) => input.length === 0);
});

const otpValue = computed(() => prop.otp.supplementaryOtp.otp.join(""));

const phoneOTP = () => {
  mobileOverlay.value = true;
  page10Overlay.value = true;
  const requestModel = {
    mobileNo:
      prop.contactInformation.supplementary.mobileCountryCode +
      prop.contactInformation.supplementary.mobileNo,
    mobileNoCountryCode:
      prop.contactInformation.supplementary.mobileCountryCode,
    otp: {
      otpValue: otpValue.value,
      otpPacNo: prop.otp.supplementaryOtp.pac,
    },
  };

  CCOnboardFormService.validateOTP(requestModel)
    .then((res) => {
      mobileOverlay.value = false;
      if (res.status == 200) {
        page10Overlay.value = false;
        errorMessage.value = false;
        prop.otp.supplementaryOtp.validated = true;
        prop.otp.supplementaryOtp.needValidate = false;
        prop.otp.supplementaryOtp.success = true;
      }
    })
    .catch((e) => {
      mobileOverlay.value = false;
      if (e.response.data.message == "4022") {
        expiredOtp.value = true;
      } else if (e.response.data.message == "4021") {
        errorMessage.value = true;
      } else {
        otpDown.value = true;
      }
      page10Overlay.value = false;
      prop.otp.supplementaryOtp.validated = false;
      prop.otp.supplementaryOtp.success = false;
      for (let index = 0; index < 6; index++) {
        const inputElement = document.getElementById(
          "input_" + index
        ) as HTMLInputElement;
        if (inputElement) {
          inputElement.value = "";
        }
      }
      const inputElement = document.getElementById("input_" + 0);
      if (inputElement) {
        inputElement.focus();
      }
      prop.otp.supplementaryOtp.otp = Array(6).fill("");
      prop.otp.supplementaryOtp.full = false;
      prop.otp.supplementaryOtp.number = prop.otp.supplementaryOtp.number + 1;
      if (prop.otp.supplementaryOtp.number >= 3 && expiredOtp.value != true) {
        maxOtp.value = true;
      }
    });
};

const emit = defineEmits([
  "nextStep",
  "previousStep",
  "submit",
  "jumpStep",
  "tokenSessionTimeOut",
]);

const checkOtpResult = () => {
  const requestModel = {
    webFormRequestId: prop.contactInformation.webFormRequestId,
    suppWebFormRequestId:
      prop.contactInformation.supplementary.webFormRequestId,
    type: "CC_S",
  };
  CCOnboardFormService.updateStatus(requestModel, prop.token)
    .then((res) => {
      if (res.status == 200) {
        prop.otp.supplementaryOtp.status = "verified";
        emit("jumpStep", 11, "", 3);
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        emit("tokenSessionTimeOut");
      }
    });
};

const next = () => {
  emit("nextStep");
};
const notEditable = ref("");
const back = () => {
  if (!prop.otp.supplementaryOtp.success) {
    notEditable.value = "falseOtp";
  }
  emit("jumpStep", 9, "", 10);
};
</script>

<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.frame-36279 {
  margin: 0 112px;
  padding: 0px 104px;
  display: flex;
  flex-direction: column;
  /* gap: 32px; */
  /* align-items: center; */
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.frame-36345 {
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 32px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 32px;
  max-width: 500px;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.pop-up-components {
  background: #f7fbff;
  border-radius: 10px;
  border-style: solid;
  border-color: #f1f1f1;
  border-width: 4px;
  padding: 24px 16px 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  flex: 1;
  position: relative;
  height: 350px;
}

.main-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}

.enter-the-6-digit-co {
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  text-align: center;
  font: var(--subtitle-1-medium, 500 16px/130% "Outfit", sans-serif);
  position: relative;
  align-self: stretch;
}

._60-86 {
  color: var(--black-high-87, rgba(0, 0, 0, 0.87));
  text-align: center;
  font: var(--body-regular, 400 16px/130% "Outfit", sans-serif);
  position: relative;
  align-self: stretch;
}

.number-tile {
  background: #f6f7f8;
  border-radius: 6px;
  border-style: solid;
  border-color: #e4e4e4;
  border-width: 1px;
  padding: 8px 12px 8px 12px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 60px;
  position: relative;
}

._1023 {
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  text-align: center;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
}

.text-field-6-digits {
  flex-shrink: 0;
  width: 100%;
  /* position: relative; */
  overflow: hidden;
  margin-left: 15px;
  text-align: center;
}

.pop-up-components.focused {
  outline: 2px solid #007bff; /* Change the color as needed */
}

.bottom-footer {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}

.already-have-an-acco {
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  text-align: center;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
}

.resendText {
  color: var(--black-low-38, rgba(0, 0, 0, 0.38));
  text-align: center;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
  margin-bottom: 0;
}

.text-button-small {
  display: flex;
  flex-direction: row;
  margin-left: 6px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
}

.text-button-default {
  color: var(--primary-active, #ac2887);
  text-align: left;
  font: var(--subtitle-2, 500 14px/130% "Outfit", sans-serif);
  position: relative;
  margin-bottom: 0;
}

input[type="tel"] {
  width: 8%;
  height: 50px;
  opacity: 1;
  text-align: center;
  margin-right: 5.5%;
  outline: 0;
  border-width: 0 0 3px;
  border-color: #cb03bc;
  color: rgba(0, 0, 0, 0.87);
  font: 400 30px/130% "Outfit";
  text-rendering: auto;
  top: calc(50% - 20px);
  padding: 0;
  box-sizing: border-box;
  background-color: transparent;
}

.help {
  color: red;
  font: 400 14px/130% "Outfit", sans-serif;
  margin-bottom: 0;
}

.helpNull {
  margin-bottom: 18px;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

input:focus {
  outline: none;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #f7fbff inset;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.process_overlay {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.5s ease forwards;
  opacity: 0;
  border-radius: 10px;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

.description {
  color: #212121;
  font: 500 22px/130% "Outfit";
  margin-bottom: 2px;
  text-align: left;
  position: relative;
}

.svg-container {
  margin-bottom: 10px; /* Adjust this value as needed */
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.5s ease forwards;
  opacity: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 955px) {
  /* .frame-36279 {
    margin: 0;
    padding: 0 50px;
  } */
}

@media (max-width: 700px) {
  .frame-36345 {
    display: block;
  }
  .frame-36345 .pop-up-components {
    margin-bottom: 32px;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }
}

.frame-36279:is(.Mobile) {
  padding: 0;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 24px;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;
  flex: 0 0 25%;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}
</style>
